// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.artist {
  color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #050505;
  filter: blur(100px);
  position: relative;
  animation: blurry 2s ease-in-out forwards;
}
.artist_profiles {
  display: flex;
}
.artist__img-container {
  width: 30%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
}
.artist__img-container:hover {
  width: 100%;
}
.artist__work {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2em;
  overflow-y: scroll;
}
.artist__bio {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1em;
  font-size: 0.8em;
  width: 100% !important;
}
.artist__bio_icon {
  position: absolute;
  top: -30%;
  left: 5%;
  width: 2em;
  height: 2em;
  background-color: orange;
  z-index: 1;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#q-mobile li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.4vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: #f3f3f3;
}

#q {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  height: 5vw;
  width: 10%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 1;
}

#q li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.4vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#q li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#q li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#q li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#q li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#q li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#q li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(8) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(9) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(10) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#q li:nth-child(11) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#q li:nth-child(12) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(13) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(14) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#q li:nth-child(15) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

.artist-btn {
  font-family: "Varela Round";
  left: 0;
  right: 0;
  margin: auto;
  bottom: -30%;
  background-color: black;
  height: 3em;
  font-size: 1.2em !important;
}

.icon {
  background-color: orange !important;
  width: 20em;
  height: 30em;
}

@media (min-width: 390px) {
  .artist_profiles {
    flex-direction: column;
  }
  #q {
    display: none;
  }
  #q-mobile li {
    font-size: 1.7em;
  }
}
@media (min-width: 1024px) {
  .artist_profiles {
    flex-direction: row;
  }
  #q {
    display: block;
  }
  #q-mobile li {
    font-size: 1.4vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Artist/Styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBCHQ;EDIR,mBAAA;EACA,kBAAA;EACA,yCAAA;AADJ;AAGI;EACE,aAAA;AADN;AAII;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;AAFR;AAIQ;EACI,WAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAJR;AAOI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AALN;AAOM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,UAAA;AALR;;AAUA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAPJ;;AAWA;EACI;IACI,mBAAA;EARN;EAWE;IACI,iBAAA;EATN;AACF;AAcA;EACI;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZJ;EAeE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbJ;EAeE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbJ;EAeE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbJ;EAeE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbJ;EAeE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbJ;EAeE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbJ;EAeE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbJ;EAeE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbJ;EAeE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbJ;AACF;AAgBE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdJ;EAiBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfJ;EAiBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfJ;EAiBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfJ;EAiBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfJ;EAiBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfJ;EAiBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfJ;EAiBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfJ;EAiBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfJ;EAiBE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAfJ;EAkBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBJ;EAkBE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAhBJ;EAmBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjBJ;EAmBE;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAjBJ;EAoBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBJ;EAoBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBJ;EAoBE;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAlBJ;AACF;AAqBE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBJ;EAsBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;EAsBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBJ;AACF;AAuBE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAwBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAwBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAwBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAwBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBJ;EAwBE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;EAwBE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBJ;AACF;AAyBE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA0BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA0BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA0BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA0BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBJ;EA0BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;EA0BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBJ;AACF;AA2BE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BJ;EA4BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;EA4BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BJ;AACF;AA6BE;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BJ;EA8BE;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BJ;EA8BE;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EA5BJ;AACF;AAgCE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCCriBQ;ADugBZ;;AAiCE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA9BJ;;AAgCE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AA7BJ;;AA+BE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA5BJ;;AA8BE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA3BJ;;AA6BE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA1BJ;;AA4BE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAzBJ;;AA2BE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAxBJ;;AA0BE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvBJ;;AAyBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAtBJ;;AAwBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AArBJ;;AAuBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AApBJ;;AAuBE;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AApBJ;;AAsBE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAnBJ;;AAqBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAlBJ;;AAqBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAlBJ;;AAoBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAjBJ;;AAmBE;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAhBJ;;AAoBE;EACE,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EAEA,WAAA;EACA,2BAAA;AAlBJ;;AAqBE;EACE,mCAAA;EACA,WAAA;EACA,YAAA;AAlBJ;;AE5oBE;EFqqBI;IACE,sBAAA;EArBN;EAyBE;IACE,aAAA;EAvBJ;EA0BG;IACC,gBAAA;EAxBJ;AACF;AE5oBE;EFyqBI;IACE,mBAAA;EA1BN;EA8BE;IACE,cAAA;EA5BJ;EA+BE;IACI,gBAAA;EA7BN;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.artist {\n    color: white;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    background-color: $bdt-black;\n    filter: blur(100px);\n    position: relative;\n    animation: blurry 2s ease-in-out forwards;\n\n    &_profiles {\n      display: flex;\n    }\n\n    &__img-container {\n        width: 30%;\n        height: 100vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        transition: all .3s ease-in-out;\n\n        &:hover {\n            width: 100%;\n        }\n    }\n\n    &__work {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 2em;\n        overflow-y: scroll;\n    }\n\n    &__bio {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 1em;\n      font-size: .8em;\n      width: 100% !important;\n      // letter-spacing: -1px;\n      &_icon {\n        position: absolute;\n        top: -30%;\n        left: 5%;\n        width: 2em;\n        height: 2em;\n        background-color: orange;\n        z-index: 1;\n      }\n    }\n}             \n                \nimg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n\n}\n\n@keyframes blurry {\n    0% {\n        filter: blur(100px);\n    }\n\n    100% {\n        filter: blur(0px);\n    }\n}\n\n\n\n@keyframes flickerL {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    100% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerO {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.66667% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    73.33333% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    74% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    74.66667% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    75.33333% {\n      color: rgba(255, 255, 255, 0.7);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n        0 0 40px white;\n    }\n    75.77778% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    94.44444% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerA {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    88.86667% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    88.88889% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerD {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    83.31111% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    83.33333% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerI {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    77.75556% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    77.77778% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerN {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.2% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    72.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n  @keyframes flickerG {\n    0% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n      // opacity: 0;\n    }\n    22.22222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    24% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    24.02222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    25.8% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    25.82222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    27.6% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    27.62222% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    29.4% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    66.64444% {\n      color: rgba(255, 255, 255, 0.26);\n      -webkit-text-stroke-color: white;\n      text-shadow: 0 0 80px white, 0 0 40px white;\n    }\n    66.66667% {\n      color: black;\n      -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n      text-shadow: none;\n    }\n    100% {\n      color: black;\n      -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n      text-shadow: none;\n      // opacity: 1;\n    }\n  }\n\n  #q-mobile li {\n    display: inline-block;\n    position: relative;\n    height: 5vw;\n    list-style: none;\n    font-family: \"Varela Round\";\n    font-weight: bolder;\n    font-size: 1.4vw;\n    color: black;\n    -webkit-text-stroke-width: 0.045vw;\n    -webkit-text-stroke-color: $bdt-white;\n  }\n\n  #q {\n    position: absolute;\n    top: 30%;\n    left: 0;\n    right: 0;\n    height: 5vw;\n    width: 10%;\n    transform: translateY(-50%);\n    margin: 0 auto;\n    text-align: center;\n    z-index: 1;\n  }\n  #q li {\n    display: inline-block;\n    position: relative;\n    height: 5vw;\n    list-style: none;\n    font-family: \"Varela Round\";\n    font-weight: bolder;\n    font-size: 1.4vw;\n    color: black;\n    -webkit-text-stroke-width: 0.045vw;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards;\n  }\n  #q li:nth-child(1) {\n    animation-name: flickerL;\n    animation-delay: 0s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(2) {\n    animation-name: flickerO;\n    animation-delay: 0.25s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(3) {\n    animation-name: flickerA;\n    animation-delay: 0.5s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(4) {\n    animation-name: flickerD;\n    animation-delay: 0.75s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(5) {\n    animation-name: flickerI;\n    animation-delay: 1s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(6) {\n    animation-name: flickerN;\n    animation-delay: 1.25s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(7) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(8) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(9) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n\n  #q li:nth-child(10) {\n    animation-name: flickerL;\n    animation-delay: 0s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(11) {\n    animation-name: flickerO;\n    animation-delay: 0.25s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(12) {\n    animation-name: flickerA;\n    animation-delay: 0.5s;\n    animation-duration: 4.5s;\n  }\n\n  #q li:nth-child(13) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(14) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n  #q li:nth-child(15) {\n    animation-name: flickerG;\n    animation-delay: 1.5s;\n    animation-duration: 4.5s;\n  }\n\n\n  .artist-btn {\n    font-family: \"Varela Round\";\n    left: 0;\n    right: 0;\n    margin: auto;\n    bottom: -30%;\n    background-color: black;\n    // width: 15em;\n    height: 3em;\n    font-size: 1.2em !important;\n  }\n\n  .icon {\n    background-color: orange !important;\n    width: 20em;\n    height: 30em;\n  }\n\n\n\n  @include screen-sm {\n    .artist {\n      &_profiles {\n        flex-direction: column;\n      }\n    }\n\n    #q {\n      display: none;\n    }\n\n     #q-mobile li {\n      font-size: 1.7em;\n     }\n  }\n\n  @include screen-lg {\n    .artist {\n      &_profiles {\n        flex-direction: row;\n      }\n    }\n\n    #q {\n      display: block;\n    }\n\n    #q-mobile li {\n        font-size: 1.4vw;\n     }\n  }","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
